import BreadcrumbsComponent from "../../components/Breadcrumbs/BreadcrumbsComponent";
import CardResumen from "../../components/CardProject/CardProject";
import "./PageInvest.css";
import "react-multi-carousel/lib/styles.css";
import { useEffect, useState } from "react";
import PageProjectDetail from "../PageProjectDetail/PageProjectDetail";
import { FIDEICOMISOS, INVERSIONES_USUARIO } from "../../constants/mockData";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import ShowChartIcon from "@mui/icons-material/ShowChart";

export default function PageInvest() {
  const [funds, setFunds] = useState([]);
  const [selectedFund, setSelectedFund] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [activeTab, setActiveTab] = useState("available");

  useEffect(() => {
    // Obtener IDs de fondos donde el usuario ya tiene inversiones
    const fondosConInversion = INVERSIONES_USUARIO.map((inv) => inv.fund);

    // Mapear los fideicomisos con la información de si tienen inversión
    const mockFunds = FIDEICOMISOS.map((fondo) => {
      const hasInvestment = fondosConInversion.includes(fondo.id);
      const inversionesDelUsuario = INVERSIONES_USUARIO.filter(
        (inv) => inv.fund === fondo.id,
      );
      const investedAmount = inversionesDelUsuario.reduce(
        (sum, inv) => sum + inv.invested_amount,
        0,
      );

      return {
        id: fondo.id,
        name: fondo.name,
        fund_type: fondo.tipo,
        category: fondo.categoria,
        gestor: fondo.gestor,
        administrador: fondo.administrador,
        price_per_unit: fondo.valor_unidad,
        amount_units: fondo.unidades_disponibles,
        expected_return: fondo.tir_anual,
        image: fondo.imagen,
        hasInvestment: hasInvestment,
        investedAmount: investedAmount,
        descripcion: fondo.descripcion,
        valor_unidad: fondo.valor_unidad,
        tir_anual: fondo.tir_anual,
        tipo: fondo.tipo,
        categoria: fondo.categoria,
        color: fondo.color,
        unidades_disponibles: fondo.unidades_disponibles,
        nuevo: fondo.nuevo,
        negociable: fondo.negociable,
      };
    });

    setFunds(mockFunds);
  }, []);

  // Filtrar fondos por búsqueda y categoría
  const filteredFunds = funds.filter((fund) => {
    const matchesSearch =
      fund.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      fund.gestor.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || fund.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Separar fondos disponibles e invertidos
  const availableFunds = filteredFunds.filter((fund) => !fund.hasInvestment);
  const investedFunds = filteredFunds.filter((fund) => fund.hasInvestment);

  // Obtener categorías únicas
  const categories = ["all", ...new Set(funds.map((fund) => fund.category))];

  // Fondos a mostrar según el tab activo
  const displayFunds =
    activeTab === "available" ? availableFunds : investedFunds;

  return (
    <>
      {selectedFund ? (
        <PageProjectDetail
          fundData={selectedFund}
          setSelectedFund={() => setSelectedFund(null)}
        />
      ) : (
        <div className="page-invest container-animated">
          <div className="row">
            <div className="col-12">
              <BreadcrumbsComponent />
            </div>
          </div>

          {/* Tabs de navegación */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="tabs-container">
                <button
                  className={`tab-btn ${activeTab === "available" ? "active" : ""}`}
                  onClick={() => setActiveTab("available")}
                >
                  <RocketLaunchIcon className="tab-icon" />
                  <span className="tab-text">Nuevas Oportunidades</span>
                  <span className="tab-badge">{availableFunds.length}</span>
                </button>
                <button
                  className={`tab-btn ${activeTab === "invested" ? "active" : ""}`}
                  onClick={() => setActiveTab("invested")}
                >
                  <ShowChartIcon className="tab-icon" />
                  <span className="tab-text">Mis Inversiones</span>
                  <span className="tab-badge">{investedFunds.length}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Barra de búsqueda y filtros */}
          <div className="row mt-3">
            <div className="col-12">
              <div className="filters-container">
                <div className="search-box">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Buscar fideicomiso por nombre o gestora..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <span className="search-icon">
                    <i className="bi bi-search"></i>
                  </span>
                </div>
                <div className="category-filters">
                  {categories.map((cat) => (
                    <button
                      key={cat}
                      className={`filter-btn ${selectedCategory === cat ? "active" : ""}`}
                      onClick={() => setSelectedCategory(cat)}
                    >
                      {cat === "all" ? "Todos" : cat}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Contenido según tab activo */}
          <div className="row mt-4">
            {displayFunds.length > 0 ? (
              displayFunds.map((data) => (
                <div
                  key={data.id}
                  className={`col-md-4 mb-4 ${data.hasInvestment ? "invested-card-wrapper" : ""}`}
                  onClick={() => setSelectedFund(data)}
                  style={{ cursor: "pointer" }}
                >
                  <CardResumen data={data} />
                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="empty-state">
                  <p className="empty-state-icon">🔍</p>
                  <p className="empty-state-text">
                    {activeTab === "available"
                      ? "No se encontraron fideicomisos disponibles con los filtros seleccionados."
                      : "No tienes inversiones que coincidan con los filtros seleccionados."}
                  </p>
                  <button
                    className="btn-reset-filters"
                    onClick={() => {
                      setSearchTerm("");
                      setSelectedCategory("all");
                    }}
                  >
                    Limpiar filtros
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
